import { render } from "./MyRoles.vue?vue&type=template&id=4bc2cab2&scoped=true"
import script from "./MyRoles.vue?vue&type=script&lang=js"
export * from "./MyRoles.vue?vue&type=script&lang=js"

import "./MyRoles.vue?vue&type=style&index=0&id=4bc2cab2&scoped=true&lang=css"
import "./MyRoles.vue?vue&type=style&index=1&id=4bc2cab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc2cab2"]])

export default __exports__